import DayPicker from 'react-day-picker';

// Here are docs for our version of react day picker:
// https://react-day-picker-v7.netlify.app/docs/getting-started
const CalendarDatePicker = (props) => {
  return <DayPicker {...props} />;
};

export default CalendarDatePicker;
